import axios from "axios";
import { Toast } from "../../util/Toast";
import {
    CLOSE_RESTRICTED_ACCOUNT_DIALOG,
    CREATE_RESTRICTED_ACCOUNT,
    DELETE_RESTRICTED_ACCOUNT,
    GET_RESTRICTED_ACCOUNT,
    UPDATE_RESTRICTED_ACCOUNT_STATUS,
} from "./types";

export const getRestrictedAccount = () => (dispatch) => {
    axios
        .get(`restrictedAccount`)
        .then((res) => {
            if (res.data.status) {
                dispatch({ type: GET_RESTRICTED_ACCOUNT, payload: res.data.restrictedAccounts });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

export const createRestrictedAccount = (data) => (dispatch) => {
    axios
        .post(`restrictedAccount`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Restricted account created successfully!");
                dispatch({ type: CLOSE_RESTRICTED_ACCOUNT_DIALOG });
                dispatch({ type: CREATE_RESTRICTED_ACCOUNT, payload: res.data.restrictedAccount });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

export const updateRestrictedAccountStatus = (restrictedAccountId, isActive) => (dispatch) => {
    axios
        .post(`restrictedAccount/${restrictedAccountId}/status`, { isActive })
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Restricted account status updated successfully!");
                dispatch({
                    type: UPDATE_RESTRICTED_ACCOUNT_STATUS,
                    payload: { data: res.data.restrictedAccount, id: restrictedAccountId },
                });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

export const deleteRestrictedAccount = (restrictedAccountId) => (dispatch) => {
    axios
        .delete(`restrictedAccount/${restrictedAccountId}`)
        .then((res) => {
            if (res.data.status) {
                dispatch({ type: DELETE_RESTRICTED_ACCOUNT, payload: restrictedAccountId });
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => console.log(error));
};
